import { render, staticRenderFns } from "./statistical-analysis-skeleton-incident-dossier-base.vue?vue&type=template&id=81dfba90&scoped=true&"
import script from "./statistical-analysis-skeleton-incident-dossier-base.ts?vue&type=script&lang=ts&"
export * from "./statistical-analysis-skeleton-incident-dossier-base.ts?vue&type=script&lang=ts&"
import style0 from "./statistical-analysis-skeleton-incident-dossier-base.scss?vue&type=style&index=0&id=81dfba90&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "81dfba90",
  null
  
)

export default component.exports